export default "__VITE_ASSET__CSLmeW5J__"